export default __webpack_public_path__ + "static/984-d9ead332ccbb6d338ab0bed7a68608df.gif";